import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddDiscountLayer from "../../components/ManageDiscount/DiscountFormPage";

const DiscountAdd = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Add Discount" link2="/discount" title2="Discount Management"  />

        <AddDiscountLayer />
      </MasterLayout>
    </>
  );
};

export default DiscountAdd;
